export default __webpack_public_path__ + "static/media/practice-growth-dashboard-logo.cf568555.jpg";